import { Theme } from "@shared/primitive-components"
import { Property } from "csstype"
import { fleetSafetyThreshold } from "../ui/const"
import { getBackgroundColor } from "../ui/styles/severity"

const scoreBetweenThresholds = (start: number, end: number, low: number, high: number, score: number) =>
  score > start && score <= end && score > low && score <= high

type Scheme = { color: Property.Color; labelColor: Property.Color; label: keyof Schemes; type: keyof Schemes }
type Schemes = {
  low: Scheme
  medium: Scheme
  high: Scheme
  severe: Scheme
}

export const threshold = (_start: number, _end: number, _score: number, theme: Theme) => {
  const [start, end, score] = [_start, _end, _score].map(Math.round)
  const color = getBackgroundColor(score, { theme })
  const schemes: Schemes = {
    low: {
      type: `low`,
      label: `low`,
      color,
      labelColor: theme.palette.full.green,
    },
    medium: {
      type: `medium`,
      label: `medium`,
      color,
      labelColor: theme.palette.full.amber,
    },
    high: {
      type: `high`,
      label: `high`,
      color,
      labelColor: theme.palette.full.orange,
    },
    severe: {
      type: `severe`,
      label: `severe`,
      color,
      labelColor: theme.palette.full.red,
    },
  }

  // Handle greyed out segments
  if (start > score) {
    let severity: keyof Schemes
    if (start >= fleetSafetyThreshold.low) severity = `low`
    else if (start >= fleetSafetyThreshold.medium) severity = `medium`
    else if (start >= fleetSafetyThreshold.high) severity = `high`
    else severity = `severe`

    return {
      type: severity,
      color: theme.palette.grey.light,
      label: schemes[severity].label,
      labelColor: schemes[severity].labelColor,
    }
  }

  // Handle each threshold case
  if (start >= fleetSafetyThreshold.low) {
    if (scoreBetweenThresholds(start, end, fleetSafetyThreshold.low, fleetSafetyThreshold.medium, score)) {
      return schemes.medium
    }
    return schemes.low
  }

  if (start >= fleetSafetyThreshold.medium) {
    if (scoreBetweenThresholds(start, end, fleetSafetyThreshold.medium, fleetSafetyThreshold.high, score)) {
      return schemes.high
    }
    return schemes.medium
  }

  if (start >= fleetSafetyThreshold.high) {
    if (scoreBetweenThresholds(start, end, fleetSafetyThreshold.high, fleetSafetyThreshold.severe, score)) {
      return schemes.severe
    }
    return schemes.high
  }

  return schemes.severe
}

export const noDataThreshold = (start: number, theme: any) => {
  if (start < fleetSafetyThreshold.high) {
    return {
      color: theme.palette.grey.light,
      label: ``,
      type: ``,
      labelColor: theme.palette.grey.dark,
    }
  }
  if (start < fleetSafetyThreshold.low) {
    return {
      color: theme.palette.grey.dark,
      label: ``,
      type: ``,
      labelColor: theme.palette.grey.dark,
    }
  }
  return {
    color: `#000000`,
    label: ``,
    type: ``,
    labelColor: theme.palette.grey.dark,
  }
}
